import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ScheduleSummaryDetailClient from './ScheduleSummaryDetailClient'
import ScheduleSummaryDetailPlanif from './ScheduleSummaryDetailPlanif'

const useStyles = makeStyles({
    table: {
    },
    detail: {
        textAlign: 'left',
        '& > div': {
            padding: '6px'
        }
    }
});

export default function ScheduleSummaryDetail(props) {
    const classes = useStyles();
    const [typeDetail, setTypeDetail] = React.useState(0);
    const [data, setData] = React.useState(null);

    useEffect(() => {
        if (props.data !== null && props.data !== undefined) {
            setData(props.data);

            // type = 0 => client type
            // type = 1 => planif type
            if (props.data?.clientDescription !== null && props.data?.clientDescription.length > 0) {
                setTypeDetail(0);
            } else {
                setTypeDetail(1);
            }
        }
    }, [props.data]);

    return (
        <div className={classes.detail}>
            {typeDetail == 0 &&
                <ScheduleSummaryDetailClient data={data} />
            }
            {typeDetail == 1 &&
                <ScheduleSummaryDetailPlanif data={data} />
            }
        </div>
    );
}